import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ShellProvider } from './ShellContext';
import AppShell from './AppShell';

/**
 * Route-level wrapper for shell pages.
 *
 * requireAuth (default true): private surfaces redirect to /login when signed
 * out. Public surfaces (Simulate, shared links) pass requireAuth={false} and
 * render the shell anonymously — the account chip becomes a Sign in entry.
 *
 * ShellProvider is mounted here (not app-wide) so league fetches only run
 * on shell routes — zero behavior change for legacy pages.
 */
const ShellLayout = ({ requireAuth = true }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="ft-loading" style={{ paddingTop: 120 }}>Setting the table…</div>;
  }
  if (requireAuth && !user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <ShellProvider>
      <AppShell>
        <Outlet />
      </AppShell>
    </ShellProvider>
  );
};

export default ShellLayout;
